module.exports = __webpack_public_path__ + "static/media/licensed.e4548b68.webp";